/**
 * A JavaScript representation of a Gyrobase object.
 * @constructor
 * @extends {Foundation.Observable}
 * @param {string} className
 * @param {string=} oid
 */
Foundation.Object = function (className, oid) {
    Foundation.Observable.call(this);
    
    /**
     * @type {string}
     */
    this.className = className;
        
    this.set("oid", oid);
};
Foundation.inherit(Foundation.Object, Foundation.Observable);

/**
 * Cause the object's values to be rectified with the server.
 * @param {string=} method
 * @return {Foundation.Promise}
 */
Foundation.Object.prototype.fault = function (method) {
    if (!method && this.get("oid")) {
        if (this.get("oid") === "new") {
            method = "POST";
        }
        else if (this.get("oid").match(/^delete:\d+/)) {
            method = "DELETE";
        }
    }
    
    if (!method) method = "GET";
    
    var result = new Foundation.API(method, this.className, this.plainObject());

    result.otherwise(function () {
        Foundation.Dev.logEvent("objectFaultFailed", {
            "request": this.plainObject(),
            "response": result.plainObject(),
            "method": method,
            "class": this.className
        })
    }.bind(this))

    return result.then(function () { this.extend(result); }.bind(this));
};
